module.exports = __webpack_public_path__ + "static/media/architecture.ce515c37.jpg";